// import "../styles/Partners.css";

// import Approcool from "../images/Approcopp.png";
// import Tecumseh from "../images/Tecumseh.png";
// import Voltas from "../images/Voltas.png";
// import Hyundai from "../images/Hyundai.png";
// import Amstrad from "../images/Amstrad.png";
// import Refcon from "../images/Refcon1.png";
// import Napoleon from "../images/Napoleon.png";
// import Blisscon from "../images/Blisscon.png";
// import Kenstar from "../images/Kenstar.png";

// export default function Partners() {
//   const partners = [Approcool, Tecumseh, Voltas, Hyundai, Amstrad, Refcon, Napoleon, Blisscon, Kenstar];

//   return (
//     <section className="partners-section">
//       <h2 className="partners-title">Our Partners</h2>

//       <div className="slider">
//         <div className="slide-track">
//           {[...partners, ...partners].map((logo, index) => (
//             <div className="slide" key={index}>
//               <img src={logo} alt={`partner-${index}`} />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

import "../styles/Partners.css";

import Approcool from "../images/Approcopp.png";
import Tecumseh from "../images/Tecumseh.png";
import Voltas from "../images/Voltas.png";
import Hyundai1 from "../images/Hyundai1.png";
import Amstrad from "../images/Amstrad.png";
import Refcon1 from "../images/Refcon1.png";
import Napoleon1 from "../images/Napoleon1.png";
import Blisscon1 from "../images/Blisscon1.png";
import Kenstar1 from "../images/Kenstar1.png";

export default function Partners() {
  const partners = [
    Approcool, Tecumseh, Voltas, Hyundai1,
    Amstrad, Refcon1, Napoleon1, Blisscon1, Kenstar1
  ];

  return (
    <section className="partners-section">
      {/* <h2 className="partners-title">Our Esteem Customers</h2> */}
            <h2 className="partners-title">Trusted By Global Brands</h2>

      <div className="slider">
        <div className="slide-track">
          {[...partners, ...partners].map((logo, index) => (
            <div className="slide" key={index}>
              <img src={logo} alt={`partner-${index}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}